import { ReactNode, FC } from "react";
import { Button } from "@chakra-ui/react";

type Props = {
  children: ReactNode;
  isFullWidth?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  onClick: () => void;
};

export const PrimaryButton: FC<Props> = props => {
  const {
    children,
    disabled = false,
    isLoading = false,
    type = "button",
    onClick
  } = props;

  const isDisabled = disabled || isLoading;

  // TypeScriptエラー回避のため型アサーション使用
  return (
    <Button
      bg="teal.400"
      color="white"
      disabled={isDisabled}
      isLoading={isLoading}
      _hover={{ opacity: 0.8 }}
      onClick={onClick}
      type={type}
      {...({} as any)}
    >
      {children}
    </Button>
  );
};
